import { useEffect } from 'react'
import { openPrivyLogin } from 'features/auth-privy/utils/open-privy-login'
import { useQueryParams } from 'shared/hooks/use-query'
import { useCheckReferralCode } from './use-check-code'

/**
 * `?referralCode=`: validates the code into `referrerIdVar`, which
 * `signInPrivy` sends with a new account, then opens the Privy sign-in.
 * An invalid code is reported by `useCheckReferralCode`; the sign-in still
 * opens.
 */
export const useReferralCodeFromUrl = () => {
  const query = useQueryParams()
  const referralCode = query.get('referralCode') || ''

  const { checkCode } = useCheckReferralCode()

  useEffect(() => {
    if (!referralCode) return

    void checkCode(referralCode).then(() => openPrivyLogin())
  }, [checkCode, referralCode])
}
